import React from "react"

import globalStyles from "../../../../App.module.scss";
import inputFile from './images/input.png'
import output from './images/output.png'
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter";
import {dracula} from "react-syntax-highlighter/dist/cjs/styles/prism";

export default function BrokenLinkChecker() {

    let data = `import sys
import urllib.request
import urllib.error


def check_url(url, timeout=5):
    request = urllib.request.Request(url, method="HEAD", headers={"User-Agent": "link-checker"})
    try:
        with urllib.request.urlopen(request, timeout=timeout) as response:
            return response.status
    except urllib.error.HTTPError as err:
        return err.code
    except Exception as err:
        return str(err)


def main():
    if len(sys.argv) < 2:
        print("Usage: python check_links.py urls.txt")
        sys.exit(1)

    with open(sys.argv[1]) as f:
        urls = [line.strip() for line in f if line.strip()]

    broken = []
    for url in urls:
        status = check_url(url)
        ok = isinstance(status, int) and status < 400
        print(f"{'OK  ' if ok else 'FAIL'}  {status}  {url}")
        if not ok:
            broken.append(url)

    print(f"\\n{len(broken)} of {len(urls)} link(s) broken.")


if __name__ == "__main__":
    main()
`

    return (
        <div className={globalStyles.article}>
            <h1>Broken link checker</h1>
            <p>Reads a list of URLs from a text file, sends a HEAD request to each, and reports which ones fail —
                a 4xx/5xx status, a timeout, or a DNS/connection error. Useful for validating links in
                documentation, a README, or a sitemap before they go stale.</p>
            <div style={{maxWidth: '800px'}}>
                <SyntaxHighlighter
                    children={data}
                    style={dracula}
                    PreTag="div"
                    language={'python'}
                />
            </div>

            <p>Input: a text file with one URL per line.</p>
            <div style={{maxWidth: '800px'}}>
                <img src={inputFile} alt={""}/>
            </div>

            <p>Output: running the checker against that file.</p>
            <div style={{maxWidth: '800px'}}>
                <img src={output} alt={""}/>
            </div>
        </div>
    )
}
